(function () {
  'use strict';

  var money = function (value) {
    return '₦' + Math.round(Number(value || 0)).toLocaleString('en-NG');
  };

  var setPressed = function (buttons, active) {
    buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button === active));
    });
  };

  var initManufacturing = function (root) {
    var routes = Array.from(root.querySelectorAll('[data-manufacturing-route]'));
    var fabrics = Array.from(root.querySelectorAll('[data-manufacturing-fabric]'));
    var quantity = root.querySelector('[data-manufacturing-quantity]');
    var outputRoute = root.querySelector('[data-summary-route]');
    var outputQuantity = root.querySelector('[data-summary-quantity]');
    var outputFabric = root.querySelector('[data-summary-fabric]');
    var outputDecoration = root.querySelector('[data-summary-decoration]');

    var update = function () {
      var activeRoute = routes.find(function (button) { return button.getAttribute('aria-pressed') === 'true'; });
      var activeFabric = fabrics.find(function (button) { return button.getAttribute('aria-pressed') === 'true'; });
      var checked = Array.from(root.querySelectorAll('[data-manufacturing-decoration]:checked')).map(function (input) { return input.value; });
      if (outputRoute) outputRoute.textContent = activeRoute ? activeRoute.dataset.label : 'Choose a route';
      if (outputQuantity) outputQuantity.textContent = quantity ? quantity.value + ' pieces' : 'Not selected';
      if (outputFabric) outputFabric.textContent = activeFabric ? activeFabric.dataset.label : 'Choose a fabric route';
      if (outputDecoration) outputDecoration.textContent = checked.length ? checked.join(', ') : 'None selected';
    };

    routes.forEach(function (button) {
      button.addEventListener('click', function () {
        setPressed(routes, button);
        update();
      });
    });
    fabrics.forEach(function (button) {
      button.addEventListener('click', function () {
        setPressed(fabrics, button);
        update();
      });
    });
    if (quantity) quantity.addEventListener('input', update);
    root.querySelectorAll('[data-manufacturing-decoration]').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  };

  var initUniforms = function (root) {
    var groups = Array.from(root.querySelectorAll('[data-uniform-group]'));
    var quantity = root.querySelector('[data-uniform-quantity]');
    var summaryUse = root.querySelector('[data-uniform-summary-use]');
    var summaryGarment = root.querySelector('[data-uniform-summary-garment]');
    var summaryBranding = root.querySelector('[data-uniform-summary-branding]');
    var summaryQuantity = root.querySelector('[data-uniform-summary-quantity]');

    var update = function () {
      var active = function (name) {
        var group = root.querySelector('[data-uniform-group="' + name + '"]');
        var selected = group && group.querySelector('[aria-pressed="true"]');
        return selected ? selected.dataset.label : 'Choose an option';
      };
      if (summaryUse) summaryUse.textContent = active('use');
      if (summaryGarment) summaryGarment.textContent = active('garment');
      if (summaryBranding) summaryBranding.textContent = active('branding');
      if (summaryQuantity) summaryQuantity.textContent = quantity ? quantity.value + ' pieces' : 'Not selected';
    };

    groups.forEach(function (group) {
      var buttons = Array.from(group.querySelectorAll('button'));
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          setPressed(buttons, button);
          update();
        });
      });
    });
    if (quantity) quantity.addEventListener('input', update);
    update();
  };

  var initBlanks = function (root) {
    var products = Array.from(root.querySelectorAll('[data-blank-product]'));
    var minus = root.querySelector('[data-blank-minus]');
    var plus = root.querySelector('[data-blank-plus]');
    var quantity = root.querySelector('[data-blank-quantity]');
    var colours = root.querySelector('[data-blank-colours]');
    var sizes = root.querySelector('[data-blank-sizes]');
    var branding = root.querySelector('[data-blank-branding]');

    var update = function () {
      var selected = products.find(function (button) { return button.getAttribute('aria-pressed') === 'true'; });
      var set = function (selector, value) {
        var element = root.querySelector(selector);
        if (element) element.textContent = value;
      };
      set('[data-blank-summary-product]', selected ? selected.dataset.label : 'Choose a blank');
      set('[data-blank-summary-quantity]', quantity ? quantity.value + ' pieces' : 'Not selected');
      set('[data-blank-summary-colours]', colours ? colours.value : 'Not selected');
      set('[data-blank-summary-sizes]', sizes ? sizes.value : 'Not selected');
      set('[data-blank-summary-branding]', branding ? branding.value : 'None');
    };

    products.forEach(function (button) {
      button.addEventListener('click', function () {
        setPressed(products, button);
        update();
      });
    });
    if (minus) minus.addEventListener('click', function () {
      quantity.value = Math.max(Number(quantity.min || 1), Number(quantity.value || 1) - 5);
      update();
    });
    if (plus) plus.addEventListener('click', function () {
      quantity.value = Number(quantity.value || 0) + 5;
      update();
    });
    [quantity, colours, sizes, branding].forEach(function (control) {
      if (control) control.addEventListener('change', update);
    });
    if (quantity) quantity.addEventListener('input', update);
    update();
  };

  var tierIndex = function (method, quantity) {
    if (method === 'screen') {
      if (quantity < 25) return 0;
      if (quantity < 50) return 1;
      if (quantity < 100) return 2;
      if (quantity < 300) return 3;
      return 4;
    }
    if (method === 'embroidery') {
      if (quantity < 10) return 0;
      if (quantity < 50) return 1;
      if (quantity < 100) return 2;
      return 3;
    }
    if (quantity < 10) return 0;
    if (quantity < 50) return 1;
    return 2;
  };

  var initDecoration = function (root) {
    root.querySelectorAll('[data-format-naira]').forEach(function (node) {
      node.textContent = money(node.dataset.formatNaira);
    });
    var tabs = Array.from(root.querySelectorAll('[data-method-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-method-panel]'));
    var rateRows = Array.from(root.querySelectorAll('[data-rate-row]'));
    var methodInput = root.querySelector('[data-price-method]');
    var itemInput = root.querySelector('[data-price-item]');
    var quantityInput = root.querySelector('[data-price-quantity]');
    var screenControls = root.querySelector('[data-screen-controls]');
    var screenSize = root.querySelector('[data-screen-size]');
    var screenColours = root.querySelector('[data-screen-colours]');
    var unitOutput = root.querySelector('[data-price-unit]');
    var totalOutput = root.querySelector('[data-price-total]');
    var setupOutput = root.querySelector('[data-price-setup]');
    var tierOutput = root.querySelector('[data-price-tier]');
    var resultNote = root.querySelector('[data-price-note]');

    var activeMethod = function () {
      return methodInput ? methodInput.value : (root.dataset.defaultMethod || 'dtg');
    };

    var rowsFor = function (method, category) {
      return rateRows.filter(function (row) {
        return row.dataset.method === method && row.dataset.category === category;
      });
    };

    var populateItems = function () {
      var method = activeMethod();
      var category = method === 'sublimation' ? 'panel' : 'base';
      var rows = rowsFor(method, category);
      if (!itemInput) return;
      itemInput.innerHTML = '';
      rows.forEach(function (row, index) {
        var option = document.createElement('option');
        option.value = row.dataset.key;
        option.textContent = row.dataset.label;
        if (index === 0) option.selected = true;
        itemInput.appendChild(option);
      });
      if (screenControls) screenControls.hidden = method !== 'screen';
      update();
    };

    var findRow = function (method, category, key) {
      return rateRows.find(function (row) {
        return row.dataset.method === method && row.dataset.category === category && row.dataset.key === key;
      });
    };

    var priceAt = function (row, index) {
      if (!row) return 0;
      var prices = (row.dataset.prices || '').split(',').map(Number);
      return Number(prices[index] || 0);
    };

    var update = function () {
      var method = activeMethod();
      var quantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
      var tier = tierIndex(method, quantity);
      var category = method === 'sublimation' ? 'panel' : 'base';
      var row = findRow(method, category, itemInput && itemInput.value);
      var unit = priceAt(row, tier);
      var setup = 0;

      if (method === 'screen') {
        var sizeKey = screenSize ? screenSize.value : 'a4';
        var colours = Math.max(1, Number(screenColours && screenColours.value || 1));
        var extra = priceAt(findRow('screen', 'extra', sizeKey), tier);
        setup = priceAt(findRow('screen', 'setup', sizeKey), 0) * colours;
        unit += Math.max(0, colours - 1) * extra;
      }

      var total = unit * quantity + setup;
      if (unitOutput) unitOutput.textContent = money(unit);
      if (totalOutput) totalOutput.textContent = money(total);
      if (setupOutput) setupOutput.textContent = money(setup);
      if (tierOutput) tierOutput.textContent = quantity + ' pieces';
      if (resultNote) {
        resultNote.textContent = method === 'screen'
          ? 'Estimate includes the selected number of screen setups. Each placement is priced separately.'
          : 'Decoration-only estimate. Garment, VAT, delivery and separately quoted artwork work are excluded.';
      }
    };

    var switchMethod = function (method) {
      if (methodInput) methodInput.value = method;
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', String(tab.dataset.methodTab === method));
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.methodPanel !== method;
      });
      populateItems();
    };

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchMethod(tab.dataset.methodTab);
      });
    });
    if (methodInput) methodInput.addEventListener('change', function () { switchMethod(methodInput.value); });
    [itemInput, quantityInput, screenSize, screenColours].forEach(function (control) {
      if (control) {
        control.addEventListener('change', update);
        control.addEventListener('input', update);
      }
    });
    switchMethod(root.dataset.defaultMethod || 'dtg');
  };

  var init = function (scope) {
    (scope || document).querySelectorAll('[data-fx-manufacturing]').forEach(initManufacturing);
    (scope || document).querySelectorAll('[data-fx-uniforms]').forEach(initUniforms);
    (scope || document).querySelectorAll('[data-fx-blanks]').forEach(initBlanks);
    (scope || document).querySelectorAll('[data-fx-decoration]').forEach(initDecoration);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
